var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resizable-pane mx-3 mb-3",style:({ cursor: _vm.cursor, userSelect: _vm.userSelect, }),on:{"mouseup":_vm.onMouseUp,"mousemove":_vm.onMouseMove}},[_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.sidebar_visible),expression:"sidebar_visible"}],staticClass:"pane resizable sidebar",style:({
        minWidth: _vm.minSize,
        maxWidth: _vm.maxSize,
        width: _vm.resizeValue + '%',
		height: '100%',
      })},[_vm._t("resizable")],2),_c('div',{staticClass:"resizer",on:{"mousedown":_vm.onMouseDown}}),_c('section',{staticClass:"pane"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }